const contactus = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Contact Us",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4 pt-4",
        children: [
          {
            title: "Questions",
            service: "categoryQuestions",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Question Added!",
              addNewSuccessMessage: "Question Added Successfully!",
              addNewErrorTitle: "Question Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Question Deleted!",
              deleteSuccessMessage: "Question Deleted Successfully!",
              deleteErrorTitle: "Question Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Question Activated!",
              activeSuccessMessage: "Question Activated Successfully!",
              activeErrorTitle: "Question Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Question Updated!",
              updateSuccessMessage: "Question Updated Successfully!",
              updateErrorTitle: "Question Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Question",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Question",
                    placeholder: "Enter Question",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  active: true,
                  description: "",
                  options: false,
                  options_list: [],
                  common_ailments: false,
                  common_ailments_list: [],
                },
              },
            },
            children: [
              {
                type: "questionsTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Questions",
                  type: "questionList",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    title: {
                      type: "text",
                      label: "Name",
                      placeholder: "Enter Name",
                      required: true,
                      info: true,
                      character_count: 250,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    description: {
                      type: "ckeditor",
                      label: "Description",
                      placeholder: "Enter Description",
                      required: true,
                      info: false,
                      character_count: 2000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    options: {
                      type: "toggle",
                      label: "Options",
                      placeholder: "Select Options",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    options_list: {
                      type: "checkObjectMultiOptions",
                      label: "Select",
                      placeholder: "Options List",
                      displayOn: "options",
                      displayOnValue: "true",
                      hideLabel: true,
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    hr2: {
                      type: "hr",
                      size: "12",
                    },
                    common_ailments: {
                      type: "toggle",
                      label: "Common Ailments",
                      placeholder: "Select Common Ailments",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    common_ailments_list: {
                      type: "checkObjectMultiAilments",
                      label: "Select2",
                      placeholder: "Common Ailments List",
                      displayOn: "common_ailments",
                      displayOnValue: "true",
                      hideLabel: true,
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    // "common_ailments_list": {
                    //     "type": 'text',
                    //     "label": 'Common Ailments List',
                    //     "placeholder": 'Select Common Ailments',
                    //     "displayOn": 'common_ailments',
                    //     "displayOnValue": 'true',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    hr3: {
                      type: "hr",
                      size: "12",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Options",
            service: "pages",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: true,
              deleteButton: true,
              addNewSuccessTitle: "Option Added!",
              addNewSuccessMessage: "Option Added Successfully!",
              addNewErrorTitle: "Option Creation Failed!",
              addNewErrorMessage: "Option try again!",
              deleteSuccessTitle: "Option Deleted!",
              deleteSuccessMessage: "Option Deleted Successfully!",
              deleteErrorTitle: "Option Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Option Activated!",
              activeSuccessMessage: "Option Activated Successfully!",
              activeErrorTitle: "Option Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Option Updated!",
              updateSuccessMessage: "Option Updated Successfully!",
              updateErrorTitle: "Option Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Option",
                submit_url: "/api/categories/$currentCategoryId/pages",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Option Title",
                    placeholder: "Enter Option Title",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  label: "",
                  link_type: "Question",
                  question: "",
                  link: "",
                  icon: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/contact_us_options/want_to_see_a_doctor.svg",
                },
              },
            },
            children: [
              {
                type: "contactUsOptionsTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Select a Topic",
                  type: "list",
                  info: true,
                  size: "4",
                  style:
                    "border-right: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    preview: {
                      type: "optionPreview",
                      label: "Preview",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    title: {
                      type: "text",
                      label: "Name",
                      placeholder: "Enter Label",
                      required: true,
                      info: true,
                      character_count: 0,
                      disabled: true,
                      class: "mr-2",
                      size: "6",
                      style: "",
                    },
                    label: {
                      type: "text",
                      label: "Label",
                      placeholder: "Enter Label",
                      required: false,
                      info: false,
                      character_count: 40,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    link_type: {
                      type: "select",
                      label: "Link Type",
                      placeholder: "Select Link Type",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "3",
                      style: "",
                      options: ["Question", "Link"],
                    },
                    question: {
                      type: "questionSelect",
                      label: "Question",
                      placeholder: "Select Question",
                      displayOn: "link_type",
                      displayOnValue: "Question",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "9",
                      style: "",
                    },
                    link: {
                      type: "text",
                      label: "Link",
                      placeholder: "Enter Link",
                      displayOn: "link_type",
                      displayOnValue: "Link",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                    // "role": {
                    //     "type": 'text',
                    //     "label": 'Role',
                    //     "placeholder": 'Enter Role',
                    //     "required": true,
                    //     "info": true,
                    //     "character_count": 250,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    // "qualifications": {
                    //     "type": 'text',
                    //     "label": 'Qualifications',
                    //     "placeholder": 'Enter Qualifications',
                    //     "required": true,
                    //     "info": true,
                    //     "character_count": 250,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    // "locations": {
                    //     "type": 'locationMultiSelect',
                    //     "label": 'Location(s)',
                    //     "inside": ['additionalProp1', 'availability', 'locations'],
                    //     "placeholder": 'Select Location',
                    //     "load_url": '',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": ""
                    // },
                    // "gender": {
                    //     "type": 'radioObject',
                    //     "label": 'Gender',
                    //     "placeholder": 'Select Gender',
                    //     "required": false,
                    //     "info": true,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": "",
                    //     "options": [
                    //         {
                    //           "name": 'Male',
                    //         },
                    //         {
                    //           "name": 'Female',
                    //         }
                    //       ]
                    // },
                    // "group": {
                    //     "type": 'groupSelect',
                    //     "label": 'Group',
                    //     "placeholder": 'Select Group',
                    //     "inside": ['additionalProp1', 'group'],
                    //     "load_url": '',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": ""
                    // },
                    // "subgroup": {
                    //     "type": 'subgroupSelect',
                    //     "label": 'Sub-Group',
                    //     "placeholder": 'Select Sub-Group',
                    //     "inside": ['additionalProp1', 'subgroup'],
                    //     "load_url": '',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": ""
                    // },
                    // "group": {
                    //     "type": 'select',
                    //     "label": 'Group',
                    //     "placeholder": 'Select Group',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": "",
                    //     "options": []
                    // },
                    // "subgroup": {
                    //     "type": 'select',
                    //     "label": 'Sub-Group',
                    //     "placeholder": 'Select Sub-Group',
                    //     "required": false,
                    //     "info": false,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "6",
                    //     "style": "",
                    //     "options": []
                    // },
                    // "description": {
                    //     "type": 'ckeditor',
                    //     "label": 'Description',
                    //     "placeholder": 'Enter Description',
                    //     "required": false,
                    //     "info": true,
                    //     "character_count": 2000,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { contactus };
